<template>
    <div class="header-challenge-select-mode">
        <h1>{{ textH1 }}</h1>
        <h2>{{ textH2 }}</h2>
        <BtnGoBack
            @click="routeSelectUser" />
</div>
</template>

<script>
    // Component imports
    import BtnGoBack from '@/components/BtnGoBack.vue';

    export default {
        components: {
            BtnGoBack,
        },

        props: {
            textH1: { type: String, default: 'Lorem Ipsum' },
            textH2: { type: String, default: 'Lorem ipsum dolor sit amet.'}
        },

        methods: {
            routeSelectUser(){
                this.$router.push('/challenge/select-user');
            }
        }
    }
</script>

<style scoped src="@/css/components/header-challenge-select-mode.css"></style>